var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.25 0C10.976 0 14 3.024 14 6.75C14 10.476 10.976 13.5 7.25 13.5C3.524 13.5 0.5 10.476 0.5 6.75C0.5 3.024 3.524 0 7.25 0ZM7.25 12C10.1502 12 12.5 9.65025 12.5 6.75C12.5 3.849 10.1502 1.5 7.25 1.5C4.349 1.5 2 3.849 2 6.75C2 9.65025 4.349 12 7.25 12ZM13.6138 12.0532L15.7355 14.1742L14.6742 15.2355L12.5532 13.1138L13.6138 12.0532Z",
    fill: "#486166"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.073504d418ebcca2e7ebda7129d727fc.svg";
export { ForwardRef as ReactComponent };